import { useNavigate, useLocation } from "react-router-dom";
import { Heading } from "./typography";
import { appColors } from "../../common/constants/colors";
import { IconArrowLeft } from "@tabler/icons-react";
import { AppRoutes } from "../../common/routes/app_routes";
type AppCardProps = {
    children: React.ReactNode;
    title?: string;
    color?: string;
    borderColor?: string;
    className?: string;
    headerAction?: React.ReactNode;
    backButton?: boolean | string; // true for default back, string for custom route
};
export function AppCard({ children, title, color = "bg-bgDefault", borderColor = "border-transparent", className = "", headerAction, backButton, }: AppCardProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const handleBackClick = () => {
        if (typeof backButton === "string") {
            navigate(backButton);
        }
        else if (location.key !== "default") {
            navigate(-1);
        }
        else {
            navigate(AppRoutes.INDEX);
        }
    };
    const backgroundColorStyle = color.startsWith("#")
        ? { backgroundColor: color }
        : {};
    return (<div className={`flex flex-col py-4 sm:py-4 ${!color.startsWith("#") ? color : ""} px-2 sm:px-4 rounded-xl border ${borderColor} overflow-hidden ${className}`} style={backgroundColorStyle}>
      {(title || backButton) && (<div className="flex flex-wrap items-center justify-between gap-4 mb-4">
          <div className="flex items-center gap-4">
            {backButton && (<button onClick={handleBackClick} className="p-2 hover:bg-uiSecondary rounded-lg transition-colors" aria-label="Back">
                <IconArrowLeft size={24} style={{
                    color: appColors.textPrimary
                }}/>
              </button>)}
            {title && (<Heading variant="h2" tone="dark">
                {title}
              </Heading>)}
          </div>
          {headerAction && <div className="max-md:w-full">{headerAction}</div>}
        </div>)}
      <div className="flex-1 min-h-0 min-w-0">{children}</div>
    </div>);
}
